(ns dre.pages.frontpage.topic-search.templates.prevalence
  (:require
   [dre.i18n.views :refer [tr]]))

(def template
  {:prevalence {:title [:<> [:span [tr "Incidence"] "/"] [tr "Prevalence"]]
                :form-sub-heading [:<>
                                   [:span [tr "Please add one or more terms for any category."]]
                                   [:span [tr "After clicking “View Results”, you can edit your question and/or search criteria."]]]
                :forms-type :common
                :forms [{:title [tr "Conditions/Symptoms"] 
                         :form-id :conditions-symptoms
                         :form-type :common
                         :required? false
                         :top-terms-type ["DIS"]
                         :operator :or
                         :examples [{:pill/type :term
                                     :pill/query "SUBAB"
                                     :pill/label "Asthma"}
                                    {:pill/type :term
                                     :pill/query "S0Bf_"
                                     :pill/label "Breast cancer"}
                                    {:pill/type :term
                                     :pill/query "SUJY3"
                                     :pill/label "Stroke"}
                                    {:pill/type :senses
                                     :pill/query "SUEly"
                                     :pill/other-senses (list "SUElz"),
                                     :pill/excluded-senses (list),
                                     :pill/label "Heart Failure"}]}
                        {:title [tr "Demographics"] 
                         :form-id :demographics
                         :form-type :common
                         :required? false
                         :top-terms-type ["DEM"]
                         :operator :and
                         :examples [{:pill/type :term
                                     :pill/query "SUVI3"
                                     :pill/label "Male"}
                                    {:pill/type :term
                                     :pill/query "SUVEQ"
                                     :pill/label "Female"}
                                    {:pill/type :term
                                     :pill/query "SUcB"
                                     :pill/label "Elderly"}
                                    {:pill/type :term
                                     :pill/query "SUKLo"
                                     :pill/label "United States"}]}
                        {:title [tr "Comorbidities"] 
                         :form-id :comorbidities
                         :form-type :common
                         :required? false
                         :top-terms-type ["DIS"]
                         :operator :and
                         :examples [{:pill/type :term
                                     :pill/query "SUHBT"
                                     :pill/label "Obesity"}
                                    {:pill/type :senses
                                     :pill/query "SUC5K"
                                     :pill/other-senses (list "SUC5I"),
                                     :pill/excluded-senses (list),
                                     :pill/label "Diabetes"} 
                                    {:pill/type :term
                                     :pill/query "SUElw"
                                     :pill/label "Heart Disease"}
                                    {:pill/type :term
                                     :pill/query "S0FA7"
                                     :pill/label "High Blood Pressure"}]}]
                :review-query-render-fn (fn [items search-query-template]
                                          [:span.text (str " What is the incidence rate/prevalence of ") (:conditions-symptoms items)
                                           " in " (:demographics items) " population(s) with "
                                           (:comorbidities items)
                                           "?"])
                :default-search-query-template :accuracy
                :search-query-templates {:accuracy {:query/pill
                                                    {:pill/type "boost"
                                                     :pill/pills
                                                     [{:pill/type "and"
                                                       :pill/pills
                                                       [{:pill/type "tag"
                                                         :pill/query "predicted/incidence_prevalence"
                                                         :pill/label "Incidence/Prevalence"}
                                                        {:template-type :conditions-symptoms
                                                         :pill/type "sentence-tag"
                                                         :pill/query "title-or-keywords"}
                                                        {:template-type :demographics
                                                         :pill/type "sentence-tag"
                                                         :pill/query "title-or-abstract-or-keywords"}
                                                        {:template-type :comorbidities
                                                         :pill/type "sentence-tag"
                                                         :pill/query "title-or-abstract-or-keywords"}]}
                                                      {:pill/type "or",
                                                       :pill/pills
                                                       [{:pill/type "and",
                                                         :pill/pills
                                                         [{:pill/type "sentence-tag",
                                                           :pill/query "title-or-abstract",
                                                           :pill/pill
                                                           {:pill/type "senses",
                                                            :pill/other-senses (list "SUIFS"),
                                                            :pill/excluded-senses (list),
                                                            :pill/label "Prevalence",
                                                            :pill/query "SU17l"}}]}
                                                        {:pill/type "sentence-tag",
                                                         :pill/query "title-or-abstract",
                                                         :pill/pill
                                                         {:pill/type "senses",
                                                          :pill/other-senses (list "SU165"),
                                                          :pill/excluded-senses (list),
                                                          :pill/label "Incidence",
                                                          :pill/query "SUFKe"}}]}
                                                      {:template-type :conditions-symptoms
                                                       :pill/type "sentence-tag"
                                                       :pill/query "title"}
                                                      {:template-type :comorbidities
                                                       :pill/type "sentence-tag"
                                                       :pill/query "title"}
                                                      {:template-type :demographics
                                                       :pill/type "sentence-tag"
                                                       :pill/query "title"}]}
                                                    :response/filter
                                                    {:search/count true :search/count-1w true :search/count-6m true}}}}})